import { ChangeEvent, TextareaHTMLAttributes, useEffect } from "react"
import { classNamesOrEmpty } from "../../../style/common";

export type ModernInputBoxProps = React.DetailedHTMLProps<TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>

export function ModernInputBox(props: ModernInputBoxProps) {
    const handleTextChange: (event: ChangeEvent<HTMLTextAreaElement>) => void = (event) => {
        if (props.onChange) {
            props.onChange(event);
        }

        event.target.style.height = 'auto';
        event.target.style.height = `${event.target.scrollHeight}px`;
    }
    
    useEffect(() => {
        if (!props.id) {
            return;
        }

        const textarea = document.getElementById(props.id);

        if (textarea) {
            textarea.style.height = 'auto';
            textarea.style.height = `${textarea.scrollHeight}px`;
        }
    }, []);


    return (
        <textarea
            {...props}
            className={`cursor-pointer disabled:cursor-default p-0 focus:border-white resize-none max-w-full text-4xl border-none w-full overflow-hidden focus:outline-none ring-0 focus:ring-indigo-500 focus:ring-2 rounded-none focus:cursor-auto focus:rounded-none focus:bg-gray-100 focus:text-gray-800 font-bold ${props.value ? "text-gray-100 bg-transparent" : "bg-white disabled:bg-transparent"} ${classNamesOrEmpty(props.className)}`}
            onFocus={(event) => event.currentTarget.select()}
            onWheel={(event) => event.currentTarget.blur()}
            onChange={handleTextChange}
        />
    )
}